import ProfilePhoto from '../../molecules/profile-photo/profile-photo';
import { WTypography } from '../../wrappers/wrapper';
import styles from './post-like-mini.module.scss';
import { TLike } from '../../../models/common';

interface PostLikeMiniProps {
  likes: TLike[];
  totalCount: number;
  onClick?: () => void;
}

function PostLikeMini({ likes, totalCount, onClick }: PostLikeMiniProps) {
  if (!totalCount) return null;

  return (
    <div className={styles['post-like-mini']} onClick={onClick}>
      <div className={styles['liked-users']}>
        {likes?.map((like, i) => (
          <div style={{ right: i * 16 }} key={like._id}>
            <ProfilePhoto
              fontSize="0.625rem"
              radius="100%"
              user={like.user}
              width="20px"
              height="20px"
            />
          </div>
        ))}
      </div>

      <WTypography className={styles['text']}>
        {`${totalCount} like${totalCount !== 1 ? 's' : ''}`}
      </WTypography>
    </div>
  );
}
export default PostLikeMini;
